<template>
	<a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="id" name="id">
					<a-input v-model:value="form.id" />
				</a-form-item>
			</div>
			<a-form-item label="知识产权类别" name="intellectualPropertyType">
				<DictSelect v-model:value="form.intellectualPropertyType" :dict-name="'intellectualsubsidy_type'" placeholder="请选择" />
			</a-form-item>
			<a-form-item label="知识产权名称" name="intellectualPropertyName">
				<a-input v-model:value="form.intellectualPropertyName" placeholder="请输入" />
			</a-form-item>
			<a-form-item label="专利号" name="patentNumber">
				<a-input v-model:value="form.patentNumber" placeholder="请输入" />
			</a-form-item>
			<a-form-item label="授权日期" name="authorizationDate">
				<date-picker v-model:value="form.authorizationDate" placeholder="请选择" />
			</a-form-item>
			<a-form-item label="取得形式" name="formAcquisition">
				<DictSelect v-model:value="form.formAcquisition" :dict-name="'intellectualsubsidy_get'" placeholder="请选择" />
			</a-form-item>
			<!--可编辑区域 end-->
		</a-form>

	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { sys_enterpriseIntellectual } from "@/api/policyService";
import DictSelect from "@/components/other/DictSelect";
import DatePicker from "@/components/form/datePicker/DatePicker";

export default {
	name: "AddOrEditModal",
	components: { DatePicker, DictSelect },
	mixins: [formMixin],
	data() {
		return {
			options: [],
			form: {
				id: null,
				intellectualPropertyType: null,
				intellectualPropertyName: null,
				patentNumber: null,
				authorizationDate: null,
				formAcquisition: null,
			},
			rules: {
				id: [],
				intellectualPropertyType: [dataCheck.required({})],
				intellectualPropertyName: [dataCheck.required({})],
				patentNumber: [dataCheck.required({})],
				authorizationDate: [dataCheck.required({})],
				formAcquisition: [dataCheck.required({})],
			},
			submitUrl: sys_enterpriseIntellectual.saveOrUpdate
		}
	},
	created() {
	},
	methods: {

	},
}
</script>
<style scoped lang="less"></style>
